import type { CrmsAttachment } from '@core/core/types'

import type { AttachmentResponse } from './__generated__/data-contracts'

export function convertToCrmsAttachment(attachment: AttachmentResponse): CrmsAttachment {
  return {
    ...attachment,
    type: 'file',
    state: attachment.isAddedToProject ? 'addedToProject' : 'notstarted',
    coordinateSystem: attachment.coordinateSystem ?? undefined,
  }
}
